import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import * as Icons from "lucide-react";

export default function ServiceCard({ service, index = 0 }) {
  const Icon = Icons[service.icon] || Icons.Wrench;

  return (
    <motion.div
      initial={{ opacity: 0, y: 50 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-60px" }}
      transition={{ duration: 0.6, ease: "easeOut", delay: index * 0.06 }}
      className="group"
      data-testid={`service-card-${service.slug}`}
    >
      <Link
        to={`/leistungen/${service.slug}`}
        className="block bg-messinger-surface/60 backdrop-blur-sm border border-white/[0.08] rounded-3xl overflow-hidden transition-all duration-500 hover:border-white/20 hover:bg-messinger-surface hover:shadow-[0_24px_60px_-20px_rgba(0,0,0,0.5)] hover:-translate-y-1"
      >
        <div className="relative h-52 overflow-hidden bg-messinger-blue">
          <img
            src={service.image}
            alt={service.title}
            className="absolute inset-0 w-full h-full object-cover hover-card-image opacity-90"
            loading="lazy"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-black/85 via-black/30 to-transparent" />
          <div className="absolute top-4 left-4 flex items-center gap-2 bg-black/60 backdrop-blur border border-white/10 px-3 py-1.5 rounded-full">
            <Icon size={14} className="text-messinger-orange" />
            <span className="text-[10px] uppercase tracking-[0.18em] text-white font-semibold">
              0{index + 1}
            </span>
          </div>
        </div>

        <div className="p-6 lg:p-7">
          <h3 className="font-heading text-lg lg:text-xl font-bold text-white leading-tight mb-3 group-hover:text-messinger-orange transition-colors">
            {service.title}
          </h3>
          <p className="text-sm text-white/60 leading-relaxed mb-5">
            {service.short}
          </p>
          <span className="inline-flex items-center gap-1.5 text-xs font-semibold tracking-[0.14em] uppercase text-messinger-orange">
            Mehr erfahren
            <ArrowUpRight
              size={14}
              className="transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5"
            />
          </span>
        </div>
      </Link>
    </motion.div>
  );
}
